<template>
  <app-page
    :dialog="dialog"
    :drawer="drawer"
    :query="tableQuery"
  >
    <template #laside>
      <el-tree
        :data="data"
        :props="defaultProps"
      ></el-tree>
    </template>
    <template #raside>
      <el-timeline>
        <el-timeline-item
          timestamp="2018/4/12"
          placement="bottom"
          v-for="i in 20"
          :key="i"
        >
          <h4>风控先生 提交于 2020/6/8 14:46</h4>
        </el-timeline-item>
      </el-timeline>
    </template>
    <template #main="{ height }">
      <el-table
        border
        :height="height - 60"
        :key="height"
        :data="new Array(30).fill({})"
      >
        <el-table-column label="ID">
          <template #default>
            <el-button
              type="text"
              @click="drawer.detail.visible = true"
            >668329</el-button>
          </template>
        </el-table-column>
        <el-table-column label="名称"></el-table-column>
        <el-table-column label="创建时间"></el-table-column>
        <el-table-column label="更新时间"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default>
            <el-button
              type="text"
              @click="dialog.edit.visible = true"
            >编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #header>
      <el-row></el-row>
      <el-row>
        <el-button
          size="small"
          type="primary"
          @click="dialog.create.visible = true"
        >添加数据</el-button>
      </el-row>
    </template>
    <template #fheader>
      <el-form
        size="small"
        inline
      >
        <el-form-item label="关键字：">
          <el-input
            v-model="tableQuery.q"
            placeholder="请输入关键字"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">查询</el-button>
          <el-button>重置</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <el-button
        size="small"
        type="primary"
      >批量操作</el-button>
    </template>
    <template #ffooter>
      <el-row>
        <el-button
          size="small"
          type="primary"
        >导出</el-button>
      </el-row>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="1000"
      ></el-pagination>
    </template>
    <template #create>
      <div>create</div>
    </template>
    <template #edit>
      <From></From>
    </template>
    <template #detail>
      <div>
        <span>为了无法计算的价值</span>
        <el-divider content-position="right">阿里云</el-divider>
      </div>
    </template>
  </app-page>
</template>

<script>
import { treeData } from './data';
import From from './form';

export default {
  components: { From },
  name: 'AppPageList',
  data() {
    return {
      data: treeData,
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      dialog: {
        create: { visible: false, title: '添加', width: '600px' },
        edit: { visible: false, title: '编辑' },
      },
      drawer: {
        detail: { visible: false, title: '详情信息' },
      },
      tableQuery: {
        q: '',
      },
    };
  },
};
</script>

<style></style>
